import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Login from '../components/Login';
import * as actions from '../actions/auth';

function mapStateToProps(state) {
  return {
    userStatus: state.auth.userStatus,
    userInfo: state.auth.userInfo,
  };
}

function mapDispatchToProps(dispatch) {
  return { actions: bindActionCreators(actions, dispatch) };
}

export default connect(mapStateToProps, mapDispatchToProps)(Login);



// WEBPACK FOOTER //
// ./src/containers/Login.js